<template>
  <button
    :type="htmlType"
    :class="classes"
    :disabled="disabled"
    @click="handleClickLink"
  >
    <span class="am-btn-loading-wrap" v-if="loading"></span>
    <!--<Icon class="ivu-load-loop" type="ios-loading" v-if="loading"></Icon>-->
    <!--<Icon :type="icon"  v-if="icon && !loading"></Icon>-->
    <span v-if="showSlot" ref="slot"><slot></slot></span>
  </button>
</template>

<script>
  // import Icon from '@/components/icon/index.vue';
  import { oneOf } from './../assist';
  const prefixCls = 'am-btn';
  export default {
    name: 'Button',
    props: {
      type: {
        validator (value) {
          return oneOf(value, ['default', 'primary', 'dashed', 'text', 'info', 'success', 'warning', 'error']);
        },
        default: 'default'
      },
      htmlType: {
        default: 'button',
        validator (value) {
          return oneOf(value, ['button', 'submit', 'reset']);
        }
      },
      size: {
        validator (value) {
          return oneOf(value, ['small', 'large', 'default']);
        },
        default: 'default'
      },
      loading: Boolean,
      disabled: Boolean,
      icon: {
        type: String,
        default: ''
      },
      ghost: {
        type: Boolean,
        default: false
      }
    },
    created() {
    },
    data() {
      return {
        showSlot: false
      }
    },
    mounted() {
      this.showSlot = this.$slots.default !== undefined;
    },
    computed: {
      classes () {
        return [
          `${prefixCls}`,
          `${prefixCls}-${this.type}`,
          {
            [`${prefixCls}-${this.size}`]: this.size !== 'default',
            [`${prefixCls}-loading`]: this.loading != null && this.loading,
            [`${prefixCls}-icon-only`]: !this.showSlot && (!!this.icon || !!this.customIcon || this.loading),
            [`${prefixCls}-ghost`]: this.ghost
          }
        ];
      }
    },
    methods: {
      handleClickLink (event, new_window = false) {
        this.$emit('click', event);
        // this.handleCheckClick(event, new_window);
      }
    },
    components: {
      // Icon
    }
  }
</script>

<style lang="less">
  // Prefix
  @css-prefix-iconfont    : am-icon;
  @css-prefix: "am-";
  @btn-prefix-cls: ~"@{css-prefix}btn";
  //mixin
  .size(@width; @height) {
    width: @width;
    height: @height;
  }

  .square(@size) {
    .size(@size; @size);
  }
  // Color
  @primary-color          : #2d8cf0;
  @info-color             : #2db7f5;
  @success-color          : #19be6b;
  @processing-color       : @primary-color;
  @warning-color          : #ff9900;
  @error-color            : #ed4014;
  @normal-color           : #e6ebf1;
  @link-color             : #2D8cF0;
  @link-hover-color       : tint(@link-color, 20%);
  @link-active-color      : shade(@link-color, 5%);
  @selected-color         : fade(@primary-color, 90%);
  @tooltip-color          : #fff;
  @subsidiary-color       : #808695;
  @rate-star-color        : #f5a623;
  // Base
  @body-background        : #fff;
  @font-family            : "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  @code-family            : Consolas,Menlo,Courier,monospace;@title-color            : #17233d;

  @text-color             : #333;
  @font-size-base         : 14px;
  @font-size-small        : 12px;
  @font-size-large        : 16px;
  @line-height-base       : 1.5;
  @line-height-computed   : floor((@font-size-base * @line-height-base));
  @border-radius-base     : 6px;
  @cursor-disabled        : not-allowed;

  // Border color
  @border-color-base      : #dcdee2;  // outside
  @border-color-split     : #e8eaec;  // inside
  @border-width-base      : 1px;            // width of the border for a component
  @border-style-base      : solid;          // style of a components border

  // Background color
  @background-color-base        : #f7f7f7;  // base
  @background-color-select-hover: @input-disabled-bg;
  @tooltip-bg                   : rgba(70, 76, 91, .9);
  @head-bg                      : #f9fafc;
  @table-thead-bg               : #f8f8f9;
  @table-td-stripe-bg           : #f8f8f9;
  @table-td-hover-bg            : #ebf7ff;
  @table-td-highlight-bg        : #ebf7ff;
  @menu-dark-title              : #323a44;
  @menu-dark-active-bg          : #363e4f;
  @menu-dark-subsidiary-color   : rgba(255,255,255,.7);
  @menu-dark-group-title-color  : rgba(255,255,255,.36);
  @date-picker-cell-hover-bg    : #e1f0fe;

  // Shadow
  @shadow-color           : rgba(0, 0, 0, .2);
  @shadow-base            : @shadow-down;
  @shadow-card            : 0 1px 1px 0 rgba(0,0,0,.1);
  @shadow-up              : 0 -1px 6px @shadow-color;
  @shadow-down            : 0 1px 6px @shadow-color;
  @shadow-left            : -1px 0 6px @shadow-color;
  @shadow-right           : 1px 0 6px @shadow-color;

  // Button
  @btn-font-weight        : normal;
  @btn-padding-base       : 5px 15px 6px;
  @btn-padding-large      : 6px 15px 6px 15px;
  @btn-padding-small      : 1px 7px 2px;
  @btn-padding-base-icon  : 5px 15px 6px;
  @btn-padding-large-icon : 6px 15px 6px 15px;
  @btn-padding-small-icon : 1px 7px 2px;
  @btn-font-size          : 12px;
  @btn-font-size-large    : 14px;
  @btn-border-radius      : 4px;
  @btn-border-radius-small: 3px;
  @btn-group-border       : shade(@primary-color, 5%);

  @btn-disable-color      : #c5c8ce;
  @btn-disable-bg         : @background-color-base;
  @btn-disable-border     : @border-color-base;

  @btn-default-color      : #fff;
  @btn-default-bg         : #3b5d8b;
  @btn-default-border     : @border-color-base;

  @btn-primary-color      : #fff;
  @btn-primary-bg         : @primary-color;

  @btn-ghost-color        : @text-color;
  @btn-ghost-bg           : #fff;
  @btn-ghost-border       : @border-color-base;

  @btn-circle-size        : 32px;
  @btn-circle-size-large  : 36px;
  @btn-circle-size-small  : 24px;
  @input-disabled-bg           : #f3f3f3;
  // Animation
  @animation-time         : .3s;
  @transition-time        : .2s;
  @ease-in-out            : ease-in-out;

  .@{btn-prefix-cls} {
    .btn;
    .btn-default;

    &-long{
      width: 100%;
    }

    & > .ivu-icon + span, & > span + .ivu-icon{
      margin-left: 4px;
    }

    &-primary {
      .btn-primary;

      .@{btn-prefix-cls}-group:not(.@{btn-prefix-cls}-group-vertical) &:not(:first-child):not(:last-child) {
        border-right-color: @btn-group-border;
        border-left-color: @btn-group-border;
      }

      .@{btn-prefix-cls}-group:not(.@{btn-prefix-cls}-group-vertical) &:first-child {
        &:not(:last-child) {
          border-right-color: @btn-group-border;
          &[disabled] {
            border-right-color: @btn-default-border;
          }
        }
      }

      .@{btn-prefix-cls}-group:not(.@{btn-prefix-cls}-group-vertical) &:last-child:not(:first-child),
      .@{btn-prefix-cls}-group:not(.@{btn-prefix-cls}-group-vertical) & + .@{btn-prefix-cls} {
        border-left-color: @btn-group-border;
        &[disabled] {
          border-left-color: @btn-default-border;
        }
      }

      .@{btn-prefix-cls}-group-vertical &:not(:first-child):not(:last-child) {
        border-top-color: @btn-group-border;
        border-bottom-color: @btn-group-border;
      }

      .@{btn-prefix-cls}-group-vertical &:first-child {
        &:not(:last-child) {
          border-bottom-color: @btn-group-border;
          &[disabled] {
            border-top-color: @btn-default-border;
          }
        }
      }

      .@{btn-prefix-cls}-group-vertical &:last-child:not(:first-child),
      .@{btn-prefix-cls}-group-vertical & + .@{btn-prefix-cls} {
        border-top-color: @btn-group-border;
        &[disabled] {
          border-bottom-color: @btn-default-border;
        }
      }
    }

    //&-ghost {
    //    .btn-ghost;
    //}

    &-dashed{
      .btn-dashed;
    }

    &-text{
      .btn-text;
    }

    &-success {
      .btn-color(@success-color);
    }

    &-warning {
      .btn-color(@warning-color);
    }

    &-error {
      .btn-color(@error-color);
    }

    &-info {
      .btn-color(@info-color);
    }

    &-circle,
    &-circle-outline {
      .btn-circle(@btn-prefix-cls);
    }

    &:before {
      position: absolute;
      top: -1px;
      left: -1px;
      bottom: -1px;
      right: -1px;
      background: #fff;
      opacity: 0.35;
      content: '';
      border-radius: inherit;
      z-index: 1;
      transition: opacity @transition-time;
      pointer-events: none;
      display: none;
    }

    &&-loading {
      pointer-events: none;
      position: relative;

      &:before {
        display: block;
      }
    }

    &-group {
      .btn-group(@btn-prefix-cls);
    }

    &-group-vertical {
      .btn-group-vertical(@btn-prefix-cls);
    }

    // The new ghost in 3.0
    &-ghost{
      color: #fff;
      background: transparent;
      &:hover{
        background: transparent;
      }
    }
    &-ghost&-dashed, &-ghost&-default{
      color: #fff;
      border-color: #fff;
      &:hover{
        color: tint(@primary-color, 20%);
        border-color: tint(@primary-color, 20%);
      }
    }
    &-ghost&-primary{
      color: @primary-color;
      &:hover{
        color: tint(@primary-color, 20%);
        background: fade(tint(@primary-color, 95%), 50%);
      }
    }
    &-ghost&-info{
      color: @info-color;
      &:hover{
        color: tint(@info-color, 20%);
        background: fade(tint(@info-color, 95%), 50%);
      }
    }
    &-ghost&-success{
      color: @success-color;
      &:hover{
        color: tint(@success-color, 20%);
        background: fade(tint(@success-color, 95%), 50%);
      }
    }
    &-ghost&-warning{
      color: @warning-color;
      &:hover{
        color: tint(@warning-color, 20%);
        background: fade(tint(@warning-color, 95%), 50%);
      }
    }
    &-ghost&-error{
      color: @error-color;
      &:hover{
        color: tint(@error-color, 20%);
        background: fade(tint(@error-color, 95%), 50%);
      }
    }

    &-ghost&-default[disabled], &-ghost&-dashed[disabled], &-ghost&-primary[disabled], &-ghost&-info[disabled], &-ghost&-success[disabled], &-ghost&-warning[disabled], &-ghost&-error[disabled]{
      background: transparent;
      color: fade(#000, 25%);
      border-color: @btn-disable-border;
    }
    &-ghost&-text[disabled]{
      background: transparent;
      color: fade(#000, 25%);
    }
  }
  .button-size(@padding; @font-size; @border-radius) {
    padding: @padding;
    font-size: @font-size;
    border-radius: @border-radius;
  }

  .button-color(@color; @background; @border) {
    color: @color;
    background-color: @background;
    border-color: @border;
    // a inside Button which only work in Chrome
    // http://stackoverflow.com/a/17253457
    > a:only-child {
      color: currentColor;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: transparent;
      }
    }
  }

  .button-variant(@color; @background; @border) {
    .button-color(@color; @background; @border);

    &:hover
      //&:focus
    {
      .button-color(tint(@color, 20%); tint(@background, 20%); tint(@border, 20%));
    }
    &:active,
    &.active {
      .button-color(shade(@color, 5%); shade(@background, 5%); shade(@background, 5%));
    }

    &.disabled,
    &[disabled],
    fieldset[disabled] & {
      &,
      &:hover,
      &:focus,
      &:active,
      &.active {
        .button-color(@btn-disable-color; @btn-disable-bg; @btn-disable-border);
      }
    }
  }

  .button-group-base(@btnClassName) {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    > .@{btnClassName} {
      position: relative;
      float: left;
      &:hover,
        //&:focus,
      &:active,
      &.active {
        z-index: 2;
      }
    }

    & .@{btnClassName}-icon-only .ivu-icon {
      font-size: 13px;
      position: relative;
      //top: 1px;
    }

    &-large .@{btnClassName}-icon-only .ivu-icon{
      font-size: 15px;
      //top: 2px;
    }

    &-small .@{btnClassName}-icon-only .ivu-icon{
      font-size: 12px;
      //top: 0;
    }

    &-circle .@{btnClassName} {
      border-radius: @btn-circle-size;
    }

    // size
    &-large&-circle .@{btnClassName} {
      border-radius: @btn-circle-size-large;
    }
    &-large {
      & > .@{btnClassName} {
        .button-size(@btn-padding-large; @btn-font-size-large; @btn-border-radius);
      }
    }

    &-small&-circle .@{btnClassName} {
      border-radius: @btn-circle-size-small;
    }
    &-small {
      & > .@{btnClassName}{
        .button-size(@btn-padding-small; @btn-font-size; @btn-border-radius-small);
        > .@{css-prefix-iconfont} {
          font-size: @btn-font-size;
        }
      }
    }

    //&-small .@{btnClassName}-icon-only{
    //    .button-size(@btn-padding-small-icon; @btn-font-size; @btn-border-radius-small);
    //}
    //&-large .@{btnClassName}-icon-only{
    //    .button-size(@btn-padding-large-icon; @btn-font-size-large; @btn-border-radius);
    //}
  }

  .button-group-vertical-base(@btnClassName) {
    display: inline-block;
    vertical-align: middle;
    > .@{btnClassName} {
      display: block;
      width: 100%;
      max-width: 100%;
      float: none;
    }
  }

  .btn() {
    display: inline-block;
    margin-bottom: 0;
    font-weight: @btn-font-weight;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    line-height: @line-height-base;
    user-select: none;
    .button-size(@btn-padding-base; @btn-font-size; @btn-border-radius);
    //transform: translate3d(0, 0, 0);
    //transition: all @transition-time linear;
    transition: color @transition-time linear, background-color @transition-time linear, border @transition-time linear, box-shadow @transition-time linear;

    > .@{css-prefix-iconfont} {
      line-height: @line-height-base;
      vertical-align: middle;
    }

    &-icon-only&-circle > .@{css-prefix-iconfont}{
      vertical-align: baseline;
    }

    > span{
      vertical-align: middle;
    }

    &,
    &:active,
    &:focus {
      outline: 0;
    }

    &:not([disabled]):hover {
      text-decoration: none;
    }

    &:not([disabled]):active {
      outline: 0;
      // transition: none;  // 如果不注释此行，那么active会和focus同时触发，此时focus的开始动画transition会无效
    }

    &.disabled,
    &[disabled] {
      cursor: @cursor-disabled;
      > * {
        pointer-events: none;
      }
    }

    &-large {
      .button-size(@btn-padding-large; @btn-font-size-large; @btn-border-radius);
    }

    &-small {
      .button-size(@btn-padding-small; @btn-font-size; @btn-border-radius-small);
    }

    &-icon-only{
      .button-size(@btn-padding-base-icon; @btn-font-size; @btn-border-radius);
    }
    &-icon-only&-small{
      .button-size(@btn-padding-small-icon; @btn-font-size; @btn-border-radius-small);
    }
    &-icon-only&-large{
      .button-size(@btn-padding-large-icon; @btn-font-size-large; @btn-border-radius);
    }
  }

  // Default
  .btn-default() {
    .button-variant(@btn-default-color; @btn-default-bg; @btn-default-border);

  }

  // Primary
  .btn-primary() {
    .button-variant(@btn-primary-color; @btn-primary-bg; @primary-color);

    &:hover,
      //&:focus,
    &:active,
    &.active {
      color: @btn-primary-color;
    }
    .active-btn-color(@primary-color);
  }

  // Ghost
  .btn-ghost() {
    .button-variant(@btn-ghost-color, @btn-ghost-bg, @btn-ghost-border);

    &:hover
      //&:focus
    {
      .button-color(tint(@primary-color, 20%); @btn-ghost-bg; tint(@primary-color, 20%));
    }
    &:active,
    &.active {
      .button-color(shade(@primary-color, 5%); @btn-ghost-bg; shade(@primary-color, 5%));
    }
    .active-btn-color(@primary-color);
  }

  // Dashed
  .btn-dashed() {
    .button-variant(@btn-ghost-color, @btn-ghost-bg, @btn-ghost-border);
    border-style: dashed;

    &:hover
      //&:focus
    {
      .button-color(tint(@primary-color, 20%); @btn-ghost-bg; tint(@primary-color, 20%));
    }
    &:active,
    &.active {
      .button-color(shade(@primary-color, 5%); @btn-ghost-bg; shade(@primary-color, 5%));
    }
    .active-btn-color(@primary-color);
  }

  // Text
  .btn-text() {
    .button-variant(@btn-ghost-color, transparent, transparent);

    // for disabled
    &.disabled,
    &[disabled],
    fieldset[disabled] & {
      &,
      &:hover,
      &:focus,
      &:active,
      &.active {
        .button-color(@btn-disable-color; @btn-ghost-bg; transparent);
      }
    }

    &:hover
      //&:focus
    {
      .button-color(tint(@primary-color, 20%); @btn-ghost-bg; transparent);
    }
    &:active,
    &.active {
      .button-color(shade(@primary-color, 5%); @btn-ghost-bg; transparent);
    }
    .active-btn-color(@primary-color);
  }

  // Color
  // for tabindex
  .active-btn-color(@color) {
    &:focus {
      box-shadow: 0 0 0 2px fade(@color, 20%);
    }
  }
  .btn-color(@color) {
    .button-variant(@btn-primary-color; @color; @color);

    &:hover,
      //&:focus,
    &:active,
    &.active {
      color: @btn-primary-color;
    }

    .active-btn-color(@color);
  }

  // Circle for Icon
  .btn-circle(@btnClassName: ivu-btn) {
    border-radius: @btn-circle-size;

    &.@{btnClassName}-large{
      border-radius: @btn-circle-size-large;
    }

    &.@{btnClassName}-size{
      border-radius: @btn-circle-size-small;
    }

    &.@{btnClassName}-icon-only{
      .square(@btn-circle-size);
      .button-size(0; @font-size-base + 2; 50%);

      &.@{btnClassName}-large{
        .square(@btn-circle-size-large);
        .button-size(0; @btn-font-size-large + 2; 50%);
      }

      &.@{btnClassName}-small{
        .square(@btn-circle-size-small);
        .button-size(0; @font-size-base; 50%);
      }
    }
  }

  // Group
  .btn-group(@btnClassName: ivu-btn) {
    .button-group-base(@btnClassName);

    .@{btnClassName} + .@{btnClassName},
    .@{btnClassName} + &,
    & + .@{btnClassName},
    & + & {
      margin-left: -1px;
    }

    .@{btnClassName}:not(:first-child):not(:last-child) {
      border-radius: 0;
    }

    &:not(&-vertical) > .@{btnClassName}:first-child {
      margin-left: 0;
      &:not(:last-child) {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }
    }

    &:not(&-vertical) > .@{btnClassName}:last-child:not(:first-child) {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }

    & > & {
      float: left;
    }

    & > &:not(:first-child):not(:last-child) > .@{btnClassName} {
      border-radius: 0;
    }

    &:not(&-vertical) > &:first-child:not(:last-child) {
      > .@{btnClassName}:last-child {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        padding-right: 8px;
      }
    }

    &:not(&-vertical) > &:last-child:not(:first-child) > .@{btnClassName}:first-child {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      padding-left: 8px;
    }
  }

  .btn-group-vertical(@btnClassName: ivu-btn) {
    .button-group-vertical-base(@btnClassName);

    .@{btnClassName} + .@{btnClassName},
    .@{btnClassName} + &,
    & + .@{btnClassName},
    & + & {
      margin-top: -1px;
      margin-left: 0px;
    }

    > .@{btnClassName}:first-child {
      margin-top: 0;
      &:not(:last-child) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    > .@{btnClassName}:last-child:not(:first-child) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    & > &:first-child:not(:last-child) {
      > .@{btnClassName}:last-child {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        padding-bottom: 8px;
      }
    }

    & > &:last-child:not(:first-child) > .@{btnClassName}:first-child {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      padding-top: 8px;
    }
  }
  .am-btn-loading-wrap {
    border: .2em dotted currentcolor;
    border-radius: 50%;
    -webkit-animation: 1s loading-rotate linear infinite;
    animation: 1s loading-rotate linear infinite;
    display: inline-block;
    width: 1em;
    height: 1em;
    color: inherit;
    vertical-align: middle;
    pointer-events: none;
    margin: 0 5px;
  }
  @keyframes loading-rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>




// WEBPACK FOOTER //
// components/Button/Button.vue